import moment from "moment";
import { mapState } from "vuex";

export const appDataMixin = {
  data() {
    return {
      startDate: "",
      endDate: "",
      filter: "",
      page: "",
      queryString: "",
      parameterQuery: "&parameter=",
      parameter: "agent",
      searchQuery: "&search=",
      searchValue: null,
      searched: false,
      perPage: 20,
      clickedApply: false,
      disabledEndDate: true,
      disabledApply: true,
      disabledInput: true,
      rcPagination: true,
      reg: /^[0-9]*[.]?[0-9]*$/,
      today: moment(Date.now()).format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState({
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      emptyImg: (state) => state.user.emptyImg,
    }),
  },
  methods: {
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    getTotalSumValue(instance) {
      const that = this;
      instance.update(that.totalSumValue);
    },
    getTotalVolume(instance) {
      const that = this;
      instance.update(that.totalVolume);
    },
    getTotalEarnings(instance) {
      const that = this;
      instance.update(that.totalEarnings);
    },
    getTotalAccountsOpened(instance) {
      const that = this;
      instance.update(that.totalAccountsOpened);
    },
    getTotalAccountsFunded(instance) {
      const that = this;
      instance.update(that.totalAccountsFunded);
    },
    getTodayData() {
      this.transactions({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
        queryString: this.queryString,
      });
      this.overview({
        startDate: this.today,
        endDate: this.today,
      });
    },
    refreshDataOrGotoPage() {
      if (this.startDate.length < 1 && this.endDate.length < 1) {
        this.getTodayData();
      } else if (this.startDate.length > 1 && this.endDate.length > 1) {
        this.applyFilter();
      }
    },
    applyFilter() {
      this.transactions({
        startDate: this.startDate,
        endDate: this.endDate,
        page: this.page ? this.page : 1,
        queryString: this.queryString,
      });
      this.overview({
        startDate: this.startDate,
        endDate: this.endDate,
      });
      if (this.route.path === "/agent-list") {
        this.getAgentList({
          page: this.page ? this.page : 1,
          queryString: this.queryString,
        });
        this.getAgentListAnalytics();
      }
    },
    clearFilter() {
      (this.startDate = ""),
        (this.endDate = ""),
        (this.searchValue = ""),
        (this.disabledEndDate = true),
        (this.disabledApply = true),
        (this.disabledInput = true);
    },
    enableEndDate() {
      this.disabledEndDate = false;
    },
    enableApply() {
      this.disabledApply = false;
      this.disabledInput = false;
    },
    clickApply() {
      this.page = 1;
      this.rcPagination = true;
      this.$route.query.page === "1"
        ? ""
        : this.$router.push({ query: { page: 1 } });
    },
    removeClass() {
      this.rcPagination = false;
    },
    getParameter() {
      this.searchValue.length > 0
        ? (this.searched = true)
        : (this.searched = false);
      if (
        this.$route.path.includes("pinpad") &&
        (this.searchValue.startsWith("fp") ||
          this.searchValue.startsWith("FP")) &&
        this.searchValue.length === 12
      ) {
        this.parameter = "terminal";
      } else if (
        this.$route.path.includes("pos") &&
        this.searchValue.startsWith("2") &&
        this.searchValue.length === 8
      ) {
        this.parameter = "terminal";
      } else if (
        !this.$route.path.includes("account") &&
        !this.searchValue.startsWith("fp") &&
        this.reg.test(this.searchValue) &&
        ((!this.searchValue.startsWith("0000") &&
          this.searchValue.length === 6) ||
          (this.searchValue.startsWith("0000") &&
            this.searchValue.length === 10))
      ) {
        this.parameter = "agent";
      } else if (
        this.$route.path.includes("account") &&
        this.reg.test(this.searchValue) &&
        this.searchValue.length === 11
      ) {
        this.parameter = "phone";
      } else if (
        !this.$route.path.includes("agent-list") &&
        !this.searchValue.startsWith("fp") &&
        this.reg.test(this.searchValue) &&
        ((!this.searchValue.startsWith("0000") &&
          this.searchValue.length === 6) ||
          (this.searchValue.startsWith("0000") &&
            this.searchValue.length === 10))
      ) {
        this.parameter = "agent";
        this.parameterQuery = "&search";
        this.searchQuery = "value";
      } else {
        this.parameter = "name";
      }
      this.queryString =
        this.searched === true
          ? this.parameterQuery +
            this.parameter +
            this.searchQuery +
            this.searchValue
          : "";
    },
  },
  watch: {
    refresh() {
      if (this.refresh === true) {
        console.log("Refresh " + this.$route.path);
        this.refreshDataOrGotoPage();
      }
    },
    "$route.query": {
      handler(query) {
        if (query.page) {
          this.page = query.page;
          this.refreshDataOrGotoPage();
        }
      },
      deep: true,
    },
  },
  created() {
    this.getTodayData();
    this.getAgentList({
      page: this.page ? this.page : 1,
    });
    this.getAgentListAnalytics().then(() => {
      this.getRatio();
    });
  },
  updated() {
    console.log(this.parameter, this.queryString);
  },
};
